import React, { Component } from 'react'
import { Route, Link, NavLink, withRouter } from 'react-router-dom'
import PrismicReact from 'prismic-reactjs'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as globalActions from '../redux/actions/globalActions'
import FocusTrap from 'react-focus-trap'

import LocaleSwitch from './LocaleSwitch'
import FontAwesomeIcon from '@fortawesome/react-fontawesome'
import faSearch from '@fortawesome/fontawesome-free-solid/faSearch'


class Header extends Component {
  constructor(props) {
    super(props)
    this.state = { 
      doc: null,
      screenWidth: 0,
      stickyHeader: '',
    }
    // this.handleSearchClick = this.handleSearchClick.bind(this)
    this.toggleMenu = this.toggleMenu.bind(this)
    this.handleClose = this.handleClose.bind(this)
    this.updateWindowWidth = this.updateWindowWidth.bind(this)
    this.handleScroll = this.handleScroll.bind(this)
  }

  componentWillMount() {
    this.findHeader(this.props)
  }
  componentWillReceiveProps(props) {
    this.findHeader(props)
  }
  componentDidMount() {
    this.updateWindowWidth()
    window.addEventListener('resize', this.updateWindowWidth)
    window.addEventListener('scroll', this.handleScroll)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowWidth)
    window.removeEventListener('scroll', this.handleScroll)
  }

  // Find header from Prismic 
  findHeader(props) {
    if(props.prismicData) {
      let doc = props.prismicData.results.find(result => result.type === 'header')
      this.setState({doc})
    }
  }
  // Update window width
  updateWindowWidth() {
    this.setState({ screenWidth: window.innerWidth })
    // Set menuOpen false on screen width bigger than 1024px
    this.state.screenWidth > 1024 ? this.props.toggleMenu(false) : null
  }

  
  // Close mobile menu
  handleClose() {
    this.props.toggleMenu(false)
  }
  // Add Sticky Class
  handleScroll(e) {
    let scrollBarPosition = window.pageYOffset | document.body.scrollTop;
    
    if(scrollBarPosition > 50 ){
      this.setState({
        stickyHeader: 'header-sticky'
      })
    } else {
      this.setState({
        stickyHeader: ''
      })
    }
  }

  // Toggle mobile menu 
  toggleMenu(e) {
    e.preventDefault()
    // this.setState({menuOpen: !this.state.menuOpen})
    this.props.toggleMenu(!this.props.menuOpen)
  }

  // Toggle search bar
  // handleSearchClick() {
  //   this.props.toggleSearch(!this.props.searchOpen)
  // }

  render() {
    if(this.state.doc) {
      const document = this.state.doc.data
      let {
        menuOpen,
        prismicCtx
      } = this.props
      
      const pageItems = document.page_items.map((page, index) => {
        return (
          page.logo_link === "Yes" ?
          <li key={index} onClick={this.handleClose} className="logo-link">
            <Link to={PrismicReact.Link.url(page.link, this.props.prismicCtx.linkResolver)}>
              <img src={document.logo.url} alt="AltaVie" className="logo" />
            </Link>
          </li> 
          :
          <li key={index} onClick={this.handleClose} className="menu-link">
            <NavLink 
              to={PrismicReact.Link.url(page.link, this.props.prismicCtx.linkResolver)} 
              activeClassName="active" 
              exact={page.name === 'Home' || page.name === 'Accueil' ? true : false}
            >
              {page.name}
            </NavLink>
          </li> 
        )
      })

      return (
        <header id="header" className={`header ${this.state.stickyHeader}`}>
          <NavLink to="/age-gate" style={{display: 'none'}} aria-hidden="true"></NavLink>
          <NavLink aria-hidden="true" to="/become-an-insider" style={{display: 'none'}} ></NavLink>
          <NavLink aria-hidden="true" to="/devenir-un-initie" style={{display: 'none'}} ></NavLink>
          <button className="hamburger-btn" onClick={this.toggleMenu}>
            <div className={`hamburger-btn-spans ${menuOpen === true ? 'close' : ''}`}>
              <span></span>
              <span></span>
              <span></span>
            </div>
          </button>
          <Link to="/" className="logo-left"><img src={document.logo.url} alt="AltaVie" className="logo" /></Link>
          <nav>
            {/* <button className="search-btn" onClick={this.handleSearchClick} style={{cursor: 'pointer'}}><FontAwesomeIcon icon={faSearch} size="sm" /></button> */}
            
            <div className={`menu-container ${menuOpen === true ? 'active' : ''}`}>
              <FocusTrap
                active={this.state.screenWidth < 1024 ? menuOpen : true} 
                paused={this.state.screenWidth < 1024 ? false : true}
                >
                <div className="flexbox menu-wrapper">
                  <ul className="menu">
                    {pageItems}
                  </ul>
                  <Link to={PrismicReact.Link.url(document.where_to_buy_link, prismicCtx.linkResolver)} className="button button-where" onClick={this.handleClose}>
                    {/* <img src="/assets/images/icon-map.svg" alt="Where To Buy"/>  */}
                    <svg width="16px" height="20px" viewBox="0 0 16 20" version="1.1">
                        <g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                            <g id="Header---Strains" transform="translate(-1252.000000, -69.000000)" fill="#C7893E" fillRule="nonzero" stroke="#C7893E" strokeWidth="0.4">
                                <g id="if_basics-23_296811" transform="translate(1252.624722, 69.282593)">
                                    <path d="M7.29690216,0.0314521645 C3.30247727,0.0314521645 0.0943564935,3.27102511 0.0943564935,7.23399783 C0.0943564935,11.1969706 7.29690216,18.9027509 7.29690216,18.9027509 C7.29690216,18.9027509 14.4994478,11.2284227 14.4994478,7.23399783 C14.4994478,3.23957294 11.2913271,0.0314521645 7.29690216,0.0314521645 Z M7.29690216,17.9591859 C6.63640671,17.2357861 5.40977229,15.8204387 4.18313788,14.153474 C1.91858203,11.1026141 0.723399783,8.71224956 0.723399783,7.20254567 C0.723399783,3.58554675 3.67990325,0.62904329 7.29690216,0.62904329 C10.9139011,0.62904329 13.8704045,3.61699892 13.8704045,7.23399783 C13.8704045,8.71224956 12.6752223,11.1340662 10.4106664,14.1849262 C9.18403203,15.8204387 7.95739762,17.2357861 7.29690216,17.9591859 Z" id="Shape"></path>
                                    <path d="M7.29690216,3.49119026 C5.40977229,3.49119026 3.9000684,5.00089415 3.9000684,6.88802402 C3.9000684,8.77515389 5.40977229,10.2848578 7.29690216,10.2848578 C9.18403203,10.2848578 10.6937359,8.77515389 10.6937359,6.88802402 C10.6937359,5.03234632 9.18403203,3.49119026 7.29690216,3.49119026 Z M9.24693636,8.86951039 C8.74370173,9.37274502 8.05175411,9.68726666 7.29690216,9.68726666 C6.54205021,9.68726666 5.8501026,9.37274502 5.34686796,8.86951039 C4.84363333,8.36627576 4.52911169,7.67432814 4.52911169,6.91947619 C4.52911169,6.16462424 4.84363333,5.47267662 5.34686796,4.96944199 C5.8501026,4.46620736 6.54205021,4.15168571 7.29690216,4.15168571 C8.05175411,4.15168571 8.74370173,4.46620736 9.24693636,4.96944199 C9.75017099,5.47267662 10.0646926,6.16462424 10.0646926,6.91947619 C10.0646926,7.67432814 9.75017099,8.36627576 9.24693636,8.86951039 Z" id="Shape"></path>
                                </g>
                            </g>
                        </g>
                    </svg>
                    {document.where_to_buy_link_name}
                  </Link>
                  <ul className="flexbox policy-items strain-info-list">
                    {
                      document.policy_items.map((item, index) => {
                        return (
                          <li key={index}>
                            <Link to={PrismicReact.Link.url(item.link, prismicCtx.linkResolver)} onClick={this.handleClose}>{item.name}</Link>
                          </li>
                        )
                      })
                    }
                  </ul>
                </div>
              </FocusTrap>
            </div>
            <LocaleSwitch/>
          </nav>
        </header>
      )
    } 
    return <div></div>
  }
}

const mapStateToProps = state => ({
  prismicCtx: state.prismic.prismicCtx,
  prismicData: state.prismic.prismicData,
  searchOpen: state.global.searchOpen,
  menuOpen: state.global.menuOpen,
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    { 
      toggleSearch: globalActions.toggleSearch, 
      toggleMenu: globalActions.toggleMenu, 
    },
    dispatch
  )

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Header))


// WEBPACK FOOTER //
// ./src/components/Header.js